import { render, staticRenderFns } from "./TheSales.vue?vue&type=template&id=00ccc3d5&"
import script from "./TheSales.vue?vue&type=script&lang=ts&"
export * from "./TheSales.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ccc3d5')) {
      api.createRecord('00ccc3d5', component.options)
    } else {
      api.reload('00ccc3d5', component.options)
    }
    module.hot.accept("./TheSales.vue?vue&type=template&id=00ccc3d5&", function () {
      api.rerender('00ccc3d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheSales.vue"
export default component.exports